import styled from 'styled-components';

export const AddItensButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 5rem;
`;
